export const environment = {
  production: true,
  application: 'DEVELOP',

  api: 'https://develop.payment-table.yooga.internal/',

  yooga_payment: 'https://payment.yooga.com.br/',
  marketing_url: 'https://marketing.yooga.com.br/',

  pagarmecheckout_app_id: 'pk_test_BLNjo8fRqTmonbOa',
  tunaEnv: 'sandbox',
  tunaAppleMerchantId: 'merchant.uy.tunahmlg',
  tunaGoogleMerchantId: 'BCR2DN6TR7QYLIKK',

  socket_url: 'wss://socket-prod.yooga.com.br/',

  version: '2026.5.2',
};